import script from "./suit-crowd.vue?vue&type=script&setup=true&lang=js"
export * from "./suit-crowd.vue?vue&type=script&setup=true&lang=js"

import "./suit-crowd.vue?vue&type=style&index=0&id=2e589f30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e589f30"]])

export default __exports__